export default __webpack_public_path__ + "static/media/habanero.5ac06326.svg";